import styled from 'styled-components';

export const PlayerBoxWrapper = styled.div`
  background-color: white;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.5);
  padding: 2px 4px;
  cursor: move;
  color: #414141;
  height: 24px;
  width: 84px;
  display: flex;
  margin-bottom: 5px;
  font-size: 11px;
  align-items: center;
  border-radius: 5px;
  font-family: 'Lato';
  font-weight: 700;
`;

export const PlayerBoxName = styled.span`
  display: block;
  width: 56px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
